import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import {
  OpportunityQuery,
  RegenerateOpportunityBuyerSummaryMutation,
  RegenerateOpportunityBuyerSummaryMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { graphql } from "../../../generated/app-service-gql";
import { useGraphQlMutation } from "../useGraphQlClient";

const REGENERATE_BUYER_ACTIVITY_MUTATION = graphql(`
  mutation regenerateOpportunityBuyerSummary($id: String!) {
    regenerateOpportunityBuyerSummary(id: $id) {
      relatedNotices {
        guid
        name
        stage
        stagev2
        expiryDate
        closeDate
        publishDate
        value
        lots {
          suppliers {
            guid
            name
          }
        }
        buyers {
          guid
        }
        procurementStage {
          id
          stage
        }
      }
      questions {
        question
        answer
      }
      status
      createdAt
    }
  }
`);
export function useRegenerateBuyerActivity(
  options?: UseMutationOptions<
    RegenerateOpportunityBuyerSummaryMutation,
    unknown,
    RegenerateOpportunityBuyerSummaryMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { data, ...rest } = useGraphQlMutation(REGENERATE_BUYER_ACTIVITY_MUTATION, {
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.setQueryData<OpportunityQuery>(["opportunity", variables.id], (oldData) => {
        if (!oldData) {
          return undefined;
        }

        return {
          ...oldData,
          opportunity: {
            ...oldData.opportunity,
            buyerActivity: data.regenerateOpportunityBuyerSummary,
          },
        };
      });
      options?.onSuccess?.(data, variables, context);
    },
  });
  return { data, ...rest };
}
